import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=6ab7b2ee&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=6ab7b2ee&prod&lang=scss&scoped=true"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=6ab7b2ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab7b2ee",
  null
  
)

export default component.exports